














import Vue from 'vue'
import Chrome from '@/assets/browsers/chrome.png'
import Edge from '@/assets/browsers/edge.png'
import Opera from '@/assets/browsers/opera.png'
import Mozilla from '@/assets/browsers/mozilla.png'
import Safari from '@/assets/browsers/safari.png'

export default Vue.extend({
  name: 'OldBrowsersDialog',

  data: () => ({
    chrome: Chrome,
    edge: Edge,
    mozilla: Mozilla,
    opera: Opera,
    safari: Safari
  })
})
